import React from 'react';
import { TrendingDown, TrendingUp } from 'lucide-react';
import { formatCurrency as formatCurrencyBase } from '../../../helpers/formatCurrency';

const EM_DASH = '—';

const formatCurrency = (value, currency) =>
  formatCurrencyBase(value, currency, { minimumFractionDigits: 0, maximumFractionDigits: 0 });

/**
 * Compact per-organization cost tile used in the mixed-currency small-multiples view.
 * Renders the org name, its native-currency cost, and an optional trend percent.
 * Designed to sit in a horizontally-scrolling row of identical tiles.
 */
const PerOrgCostTile = ({ organizationName, currency, currentTotalCost, variationPercent }) => {
  const trendVisible = variationPercent !== null && variationPercent !== undefined;
  const up = trendVisible && variationPercent > 0;
  const flat = trendVisible && variationPercent === 0;
  const trendColor = !trendVisible ? '#9ca3af' : (flat ? '#6b7280' : (up ? '#ef4444' : '#10b981'));
  const TrendIcon = !trendVisible || flat ? null : (up ? TrendingUp : TrendingDown);
  const sign = up ? '+' : '';

  return (
    <div
      className="flex-shrink-0 rounded p-3"
      style={{
        backgroundColor: '#fff',
        border: '1px solid #e5e7eb',
        minWidth: 180,
        maxWidth: 220,
      }}
    >
      <div
        className="text-muted text-truncate mb-1"
        style={{ fontSize: '0.75rem' }}
        title={organizationName || ''}
      >
        {organizationName || EM_DASH}
      </div>
      <div className="fw-bold mb-1" style={{ fontSize: '1.25rem' }}>
        {formatCurrency(currentTotalCost, currency)}
      </div>
      {trendVisible ? (
        <div className="d-inline-flex align-items-center gap-1" style={{ color: trendColor, fontSize: '0.8rem' }}>
          {TrendIcon ? <TrendIcon size={14} /> : null}
          <span>{sign}{Number(variationPercent).toFixed(1)}%</span>
        </div>
      ) : (
        <span className="text-muted" style={{ fontSize: '0.8rem' }}>{EM_DASH}</span>
      )}
    </div>
  );
};

export default PerOrgCostTile;
